import { ID } from 'api'

export interface ProductMock {
  id: ID
  cmsId: ID
  name: string
  advertiserCmsId: ID
}

export const products: ProductMock[] = [
  {
    cmsId: '123521',
    id: '1',
    name: 'Lords Mobile: Tower Defense',
    advertiserCmsId: '123',
  },
  {
    cmsId: '123520',
    id: '2',
    name: 'Web product',
    advertiserCmsId: '123',
  },
  {
    cmsId: '123490',
    id: '3',
    name: 'Tinder - Dating, Make Friends and Meet New People',
    advertiserCmsId: '124',
  },
  {
    cmsId: '314037',
    id: '4',
    name: 'FINAL FANTASY VII',
    advertiserCmsId: '124',
  },
  {
    cmsId: '234112',
    id: '5',
    name: 'MORTAL KOMBAT: The Ultimate Fighting Game!',
    advertiserCmsId: '125',
  },
  {
    cmsId: '123451',
    id: '6',
    name: 'Facebook',
    advertiserCmsId: '125',
  },
  {
    cmsId: '321333',
    id: '7',
    name: 'Lords: Tower Defense',
    advertiserCmsId: '126',
  },
  {
    cmsId: '546675',
    id: '8',
    name: 'Web product design',
    advertiserCmsId: '126',
  },
  {
    cmsId: '445667',
    id: '9',
    name: 'Make Friends and Meet New People',
    advertiserCmsId: '127',
  },
  {
    cmsId: '467774',
    id: '10',
    name: 'FINAL FANTASY VI',
    advertiserCmsId: '127',
  },
  {
    cmsId: '675677',
    id: '11',
    name: 'MORTAL KOMBAT: Fatality!',
    advertiserCmsId: '128',
  },
  {
    cmsId: '884555',
    id: '12',
    name: 'Amazon',
    advertiserCmsId: '128',
  },
  {
    cmsId: '989890',
    id: '13',
    name: 'SkyWatcher: Star Guide',
    advertiserCmsId: '129',
  },
  {
    cmsId: '456789',
    id: '14',
    name: 'Epic Adventure Games',
    advertiserCmsId: '129',
  },
  {
    cmsId: '564123',
    id: '15',
    name: 'Quantum Analytics',
    advertiserCmsId: '130',
  },
  {
    cmsId: '987654',
    id: '16',
    name: 'Crysis Warhead',
    advertiserCmsId: '130',
  },
  {
    cmsId: '234567',
    id: '17',
    name: 'Circuit Design Pro',
    advertiserCmsId: '131',
  },
  {
    cmsId: '654321',
    id: '18',
    name: 'HealthTrack: Fitness Planner',
    advertiserCmsId: '131',
  },
  {
    cmsId: '123456',
    id: '19',
    name: 'Elite Soccer League',
    advertiserCmsId: '132',
  },
  {
    cmsId: '456012',
    id: '20',
    name: 'Space Conquerors: Galactic War',
    advertiserCmsId: '132',
  },
  {
    cmsId: '123116',
    id: '21',
    name: 'Elite Soccer Kick',
    advertiserCmsId: '133',
  },
  {
    cmsId: '452122',
    id: '22',
    name: 'Space Conquerors',
    advertiserCmsId: '133',
  },
  {
    cmsId: '123426',
    id: '23',
    name: 'Elite Kick',
    advertiserCmsId: '134',
  },
  {
    cmsId: '124455',
    id: '24',
    name: 'Space',
    advertiserCmsId: '134',
  },
]
